import { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { breakpoints, colors } from 'theme/variables';

import { FormHeader, MainFormHeader } from './styled';

const PaddedSectionWrapper = styled.section<{ grayBg?: boolean; bottomBorder?: boolean }>(
    ({ grayBg, bottomBorder }) => `
    width: 100%;
    margin: 0 auto;
    background-color: ${grayBg ? colors.lightGray : colors.primaryWhite};
    border-bottom: ${bottomBorder ? '1px solid #edf0f4' : 'none'};

    > div {
        padding: 1rem;
        margin: 0 auto;
    }

    ${breakpoints.small} {
        > div {
            padding: 1.25rem;
        }
    }

    ${breakpoints.medium} {
        > div {
            padding: 1.5rem 2rem;
        }
    }

    ${breakpoints.desktop} {
        > div {
            padding: 2rem 2.5rem;
        }
    }
`,
);

type Props = PropsWithChildren<{
    header?: JSX.Element | string;
    bigHeader?: boolean;
    grayBg?: boolean;
    bottomBorder?: boolean;
}>;

export const PaddedSection = ({ header, bigHeader, grayBg, bottomBorder, children }: Props) => {
    const HeaderComponent = bigHeader ? MainFormHeader : FormHeader;

    return (
        <PaddedSectionWrapper grayBg={grayBg} bottomBorder={bottomBorder}>
            <div>
                {header ? <HeaderComponent>{header}</HeaderComponent> : null}
                {children}
            </div>
        </PaddedSectionWrapper>
    );
};
